var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaypoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 68,
    viewBox: "0 0 92 68",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h92v68h-92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1277.132 104.727-1.472 6.662-1.47 6.66-5.035-4.6-5.031-4.6 6.5-2.057 6.5-2.057zm-17.732 19.112 9.814-10.455m-19.8-.351 3.712 8.679m-18.637-7.817 7.435-3.544m-11.366 10.108a4.458 4.458 0 1 0 -4.457-4.457 4.458 4.458 0 0 0 4.457 4.457zm16.459-6.894a5.639 5.639 0 1 0 -5.639-5.639 5.639 5.639 0 0 0 5.639 5.639zm7.929 21.513a6.806 6.806 0 1 0 -6.805-6.805 6.806 6.806 0 0 0 6.8 6.806z",
    stroke: "#3a3a3a",
    strokeWidth: 2,
    transform: "translate(-1224.596 -84.788)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaypoints);
export default __webpack_public_path__ + "static/media/waypoints.e115fbb9ea5e1567226bd86702e7c79a.svg";
export { ForwardRef as ReactComponent };